import { render, staticRenderFns } from "./ControlsMobileFullscreen.vue?vue&type=template&id=0875a655&scoped=true&"
import script from "./ControlsMobileFullscreen.vue?vue&type=script&lang=js&"
export * from "./ControlsMobileFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./ControlsMobileFullscreen.vue?vue&type=style&index=0&id=0875a655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875a655",
  null
  
)

export default component.exports